import data, { EmojiMartData } from '@emoji-mart/data';
import { TFunction } from 'i18next';

export const definedTime = (t: TFunction) => [
  {
    value: 1800,
    label: t('for_30_minutes'),
  },
  {
    value: 3600,
    label: t('for_1_hour'),
  },
  {
    value: 7200,
    label: t('for_2_hours'),
  },
  {
    value: 86400,
    label: t('until_tomorrow'),
  },
  {
    value: 604800,
    label: t('until_next_week'),
  },
];

export const suggestedStatusMessages = [
  {
    emoticon: (data as EmojiMartData)?.emojis?.handshake?.skins?.[2]?.native,
    message: 'In a meeting',
    duration: 3600,
    time: '1 hour',
  },
  {
    emoticon: (data as EmojiMartData)?.emojis?.airplane?.skins?.[0]?.native,
    message: 'Travelling',
    duration: 604800,
    time: '1 week',
  },
  {
    emoticon: (data as EmojiMartData)?.emojis?.palm_tree?.skins?.[0]?.native,
    message: 'Vacationing',
    duration: 1209600,
    time: '2 weeks',
  },
];

export const defaultEmoji = (data as EmojiMartData)?.emojis?.zzz.skins?.[0]?.native;
